import { ApplicationState } from './../index';

export const GetUrlBuilderData = (state: ApplicationState) => state.urlBuilder;
export const selectBuilderPermissions = (state: ApplicationState) => state.urlBuilder.permissions;
